import React, { useState } from "react";
import { WhatsAppRequest } from "../../Services/API";

const WhatsAppTicket = () => {
  const [whatsAppNumber, setWhatsAppNumber] = useState("");
  const [pricingOption, setPricingOption] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClickWhatsApp = async () => {
    // Validation
    if (!whatsAppNumber) {
      alert("Please enter WhatsApp mobile number");
      return;
    }

    // Indian mobile validation (10 digits starting 6-9)
    const mobileRegex = /^[6-9]\d{9}$/;
    if (!mobileRegex.test(whatsAppNumber)) {
      alert("Please enter valid 10-digit mobile number");
      return;
    }

    if (!pricingOption) {
      alert("Please select a pricing option");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        mobile: whatsAppNumber,
        pricingOption: pricingOption,
      };

      const response = await WhatsAppRequest(payload);

      if (response?.status === 200) {
        alert("WhatsApp message sent successfully!");
        setWhatsAppNumber("");
        setPricingOption("");
        window.location.reload();
      } else {
        alert("Failed to send WhatsApp message.");
      }
    } catch (error) {
      console.error("WhatsApp Error:", error);
      alert("Something went wrong while sending WhatsApp message.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="form_row">
          <label className="required">WhatsApp Mobile Number</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Mobile Number..."
            value={whatsAppNumber}
            onChange={(e) => setWhatsAppNumber(e.target.value)}
            maxLength={10}
          />
        </div>
      </div>

      {/* <div className="col-md-12 mt-3">
        <p>Select Desired Pricing Option (you can select only one option)</p>

        <div className="d-flex">
          <div className="form-check m-3">
            <input
              type="radio"
              className="form-check-input"
              id="radio7"
              name="pricingOption"
              value="withPrice"
              checked={pricingOption === "withPrice"}
              onChange={(e) => setPricingOption(e.target.value)}
            />
            <label className="form-check-label" htmlFor="radio7">
              With Price
            </label>
          </div>

          <div className="form-check m-3">
            <input
              type="radio"
              className="form-check-input"
              id="radio8"
              name="pricingOption"
              value="withoutPrice"
              checked={pricingOption === "withoutPrice"}
              onChange={(e) => setPricingOption(e.target.value)}
            />
            <label className="form-check-label" htmlFor="radio8">
              Without Price
            </label>
          </div>

          <div className="form-check m-3">
            <input
              type="radio"
              className="form-check-input"
              id="radio9"
              name="pricingOption"
              value="hideMarkup"
              checked={pricingOption === "hideMarkup"}
              onChange={(e) => setPricingOption(e.target.value)}
            />
            <label className="form-check-label" htmlFor="radio9">
              Hide Markup
            </label>
          </div>
        </div>
      </div> */}

      <div className="col-md-12 text-end mt-3">
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={handleClickWhatsApp}
          disabled={loading}
        >
          {loading ? "Sending..." : "WhatsApp Me"}
        </button>
      </div>
    </div>
  );
};

export default WhatsAppTicket;
